/* eslint-disable react/no-unstable-nested-components */
import React from 'react';
import parse from 'html-react-parser';
import Image from '@ecs/tng-common/components/image/Image';
// import { Link } from 'gatsby';
import { placeholderDarker } from '@ecs/tng-common/scripts/media';
import { themes, IPost } from '../helpers/interfaces';
import ByLine from './ByLine';
import { returnTexturedClass, returnThemeBg, truncateText } from '../helpers/functions';
import ROUTES from '../helpers/routes';
import placeholderImg from '../../static/graphics/social-experian-generic.svg';

export const popularPostsLimit = 6;
type PopularPostsProps = {
  content: IPost[];
  toHideAuthor?: boolean;
  toHideCategory?: boolean;
  className?: string;
  theme: themes;
  heading: string;
  textured?: boolean;
};

export default class PopularPosts extends React.Component<PopularPostsProps> {
  render() {
    const { toHideAuthor, toHideCategory } = this.props;
    const featuredArticle = this.props.content[0];
    const featuredArticleImage = featuredArticle?.expPostContent?.featImg;
    const excerpt = truncateText(featuredArticle?.excerpt ?? '', 90);
    // Remove the first element and get up to 5 elements from the array
    const otherArticles = this.props.content.slice(1, popularPostsLimit);
    const setClassName =
      this.props.content?.length > 1
        ? `${this.props.className || ''} pop-art-${this.props.theme} ${returnTexturedClass(this.props.theme, this.props.textured)} ${returnThemeBg(this.props.theme)}`
        : '';
    /* const getTracking = (article: IPost) => {
      return `ae-mod-popularposts-c${article.categories?.nodes[0]?.databaseId}`;
    }; */
    // REPLACE WITH GATSBY LINK
    return (
      <section className={setClassName}>
        <div className="container container-py">
          <div className="row justify-content-between">
            <h2 className="content-mb">{parse(this.props.heading)}</h2>
            <div className="col-12 col-md-6">
              <a
                // data-link-cs={getTracking(featuredArticle)}
                href={ROUTES.BLOG.toUrl(featuredArticle?.uri ?? '')}
                className={`post-link-${this.props.theme}`}>
                <div className="rounded-3 mb-4 position-relative overflow-hidden">
                  <div
                    aria-hidden="true"
                    className="post-link-overlay"
                  />
                  <Image
                    className="w-100 d-block img-fluid"
                    alt={featuredArticleImage?.alt}
                    src={
                      featuredArticleImage?.src || featuredArticleImage?.srcWebP || placeholderImg
                    }
                    placeholder={placeholderDarker}
                    width="351"
                    height="200"
                    lazyLoading
                  />
                </div>
                <h3>
                  <span className="post-link-title">{parse(featuredArticle?.title)}</span>
                </h3>
                <p
                  className={`mb-2 post-link-text ${this.props.theme === 'dark' ? 'text-white text-opacity-70' : 'text-gray'}`}>
                  {parse(excerpt)}
                </p>
              </a>
              <ByLine
                author={toHideAuthor ? undefined : featuredArticle?.author?.node}
                date={featuredArticle?.date}
                theme={this.props.theme}
                category={toHideCategory ? undefined : featuredArticle?.categories?.nodes[0]}
                databaseId={featuredArticle?.databaseId}
                isAuthorLink={false}
                authorImgLazyLoading
              />
            </div>
            <div className="col-12 col-md-6 col-lg-5">
              {otherArticles.map((art, i) => (
                <div
                  className={`pop-art-skinny ${i !== otherArticles.length - 1 ? 'border-bottom mb-4 pb-3' : ''} ${this.props.theme === 'dark' ? 'border-white border-opacity-20' : ''}`}
                  key={`${art.databaseId}-pop-art`}>
                  <a
                    // data-link-cs={getTracking(art)}
                    className={`post-link-${this.props.theme}`}
                    href={ROUTES.BLOG.toUrl(art.uri ?? '')}>
                    <h3 className="h5">
                      <span className="post-link-title">{parse(art.title)}</span>
                    </h3>
                  </a>
                  <ByLine
                    theme={this.props.theme}
                    author={toHideAuthor ? undefined : art?.author?.node}
                    category={toHideCategory ? undefined : art?.categories?.nodes[0]}
                    date={art?.date}
                    databaseId={art.databaseId}
                    isAuthorLink={false}
                    authorImgLazyLoading
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    );
  }
}
